import React from 'react';
import PropTypes from 'prop-types';
/**
 * Empty state for a success process.
 *
 * @version 1.0.0
 * @author [Nagy Gergely](https://github.com/gergely-nagy)
 */
const EmptyState = (props) => {
  return (
    <div className="empty-state animated fadeIn">
      {props.hasImage && (
        <img
          src={process.env.PUBLIC_URL + '/img/empty.svg'}
          className="img-fluid"
          alt="img-avatar"
          style={{ maxWidth: 100, maxHeight: 100 }}
        />
      )}
      <h3>{props.title}</h3>
      <p>{props.subtitle}</p>
    </div>
  );
};

EmptyState.propTypes = {
  /** boolean to control the image visibility of the SuccessEmptyState */
  hasImage: PropTypes.bool,
  /** function for the button's onClick */
  submitClick: PropTypes.func,
  /** custom title of the SuccessEmptyState */
  title: PropTypes.string,
  /** custom subtitle of the SuccessEmptyState */
  subtitle: PropTypes.string,
  /** custom button title of the SuccessEmptyState */
  btnText: PropTypes.string,
};

// Specifies the default values for props:
EmptyState.defaultProps = {
  hasImage: false,
  title: `Még nem választottál jegyet!`,
  subtitle: `Jegyválasztáshoz először válassz jegytípust.`,
};

export default EmptyState;
